import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class StationAttempt extends Model<Schemas['stationAttempts'], Models> {
    get startedAtDate() {
        return nullableDate(this.startedAt);
    }

    get finishedAtDate() {
        return nullableDate(this.finishedAt);
    }
}
